<template>
    <div class="hero__arrow">
        <Container class="text-right">
            <router-link :to="`#${anchor || 'Hero'}End`" 
                class="hero__scrolldown d-none d-sm-inline"
                v-track:click="{ category: 'ScrollToAnchor', label: `#${anchor || 'Hero'}End` }">
                <fa-icon :icon="['fas', 'angle-down']" size="4x"></fa-icon>
            </router-link>
            <div :id="`${anchor || 'Hero'}End`" class="hero__end"></div>
        </Container>
    </div>
</template>
<script>
export default {
    props: ['anchor']
}
</script>
